<template>
    <div class="flex flex-col items-center md:flex-row items-start gap-4">
        <!-- Lazy Image -->
        <LazyImage :src="bookingDetail.Images[0]?.Filename" :alt="$t('checkout.propertyImageAlt')"
        :class="imageClass" />

        <!-- Property Details -->
        <div class="flex flex-col justify-center gap-2 w-full">
            <h3 class="text-xs md:text-sm text-gray-500">{{ bookingDetail?.PropertyName || bookingDetail?.RoomTypeName }}</h3>
            <h3 class="text-lg md:text-xl font-semibold">{{ bookingDetail.Room?.Name }}</h3>
            <p v-if="isShowLocation" class="text-gray-500 text-xs md:text-sm">{{ bookingDetail.ProvinceName }} , {{ bookingDetail.CityName }}</p>

            <!-- <div class="flex items-center text-yellow-500">
                <AppIcon icon="mdi:star" class="w-4 h-4 mr-1" />
                <span class="text-xs md:text-sm font-semibold">{{ bookingDetail.rating }} ({{ bookingDetail.reviewsCount
                    }} reviews)</span>
            </div> -->

            <div class="text-gray-600 text-xs md:text-sm flex flex-wrap items-center gap-4">
                <div class="flex items-center gap-1">
                    <AppIcon icon="mdi:account" class="w-4 h-4" />
                    <span>{{ bookingDetail.Pax }} {{ $t("checkout.guest.guests") }}</span>
                </div>
                <div class="flex items-center gap-1">
                    <AppIcon icon="mdi:arrow-expand-horizontal" class="w-4 h-4" />
                    <span>{{ bookingDetail.Room?.SizeRoom }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PropertyDetailCard",
    props: {
        bookingDetail: {
            type: Object,
            required: true,
            default: () => ({
                imageUrl: "",
                propertyName: "[ Nama Property ]",
                title: "",
                location: "",
                rating: 0,
                reviewsCount: 0,
                guests: 0,
                size: "",
            }),
        },
        isShowLocation : {
            type: Boolean,
            default: true,
        },
        imageClass: { // Tambahkan props untuk class LazyImage
            type: String,
            default: "w-full md:w-[140px] h-[80px] rounded-lg object-cover mb-4 md:mb-0 md:mr-4",
        },
    },
    mounted() {
        console.log("bookingDetail", this.bookingDetail);
    }
};
</script>

<style scoped>
/* Tambahkan style tambahan jika diperlukan */
</style>